/** ISO YYYY-MM-DD ↔ display DD/MM/YYYY. */

export function isoToDdMmYyyy(iso) {
  const s = String(iso ?? '').trim().slice(0, 10);
  const m = s.match(/^(\d{4})-(\d{2})-(\d{2})$/);
  if (!m) return '';
  return `${m[3]}/${m[2]}/${m[1]}`;
}

export function ddMmYyyyToIso(text) {
  const t = String(text ?? '').trim();
  if (!t) return '';
  const iso = t.match(/^(\d{4})-(\d{2})-(\d{2})$/);
  if (iso) return validIso(Number(iso[1]), Number(iso[2]), Number(iso[3]));
  const dm = t.match(/^(\d{1,2})[/\-.](\d{1,2})[/\-.](\d{4})$/);
  if (!dm) return null;
  return validIso(Number(dm[3]), Number(dm[2]), Number(dm[1]));
}

function validIso(year, month, day) {
  if (!Number.isFinite(year) || !Number.isFinite(month) || !Number.isFinite(day)) return null;
  const dt = new Date(year, month - 1, day);
  if (dt.getFullYear() !== year || dt.getMonth() !== month - 1 || dt.getDate() !== day) return null;
  return `${String(year).padStart(4, '0')}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
}

export function emitDateChange(onChange, iso, name) {
  if (typeof onChange !== 'function') return;
  onChange({ target: { value: iso, name: name || undefined } });
}
